import { getLocale } from "../runtime";

const sv_contactsupport = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Kontakta support`
};

const contactsupport = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_contactsupport(inputs)
	return "contactSupport";
};

export { contactsupport as "contactSupport" };